import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { VoterSearchContainerComponent } from "./components/container/container.component";
// import { AddVolunteerComponent } from "./components/add-volunteer/add-volunteer.component";
import { VoterSearchConfigComponent } from "./components/voter-search-config/voter-search-config.component";
import { PublicSearchHistoryComponent } from "./components/public-search-history/public-search-history.component";

const routes: Routes = [
  { path: "search", component: VoterSearchContainerComponent },
  // { path: "volunteer", component: AddVolunteerComponent },
  { path:"",component:VoterSearchConfigComponent},
  { path: "history",component:PublicSearchHistoryComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VoterSearchRoutingModule {}
